import React, { ReactNode, createContext, useContext, useEffect, useState } from 'react'

export interface Ga4Data {
  case_type?: string
  step?: string
  form_name?: string
  user_id?: string
  is_customer?: string
  page_subcategory?: string
}

interface Ga4ContextType {
  ga4Data: Ga4Data | undefined
  updateGa4Data: (newData: Ga4Data) => void
  setFormName: (formName: string) => void
}

const Ga4Context = createContext<Ga4ContextType | undefined>(undefined)

export const useGa4Context = (): Ga4ContextType => {
  const context = useContext(Ga4Context)
  if (!context) {
    throw new Error('useGa4Context must be used within a Ga4ContextProvider')
  }
  return context
}

export const Ga4ContextProvider = (props: { children: ReactNode }) => {

  const [ga4Data, setGa4Data] = useState<Ga4Data>({})

  const ga4DataInstance: Ga4ContextType = {
    ga4Data: ga4Data,
    updateGa4Data: (newData: Ga4Data) => {
      _updateData(newData)
    },
    setFormName: (formName: string) => {
      const newData: Ga4Data = {form_name: formName}
      _updateData(newData)
    },
  }

  function _updateData(newData: Ga4Data) {
    // console.log("ga4context::_updateData::newData", newData)

    // In this version, setGa4Data receives a function that takes the previous state (prevData)
    // as an argument and returns the new state. This ensures that you're always working with
    // the latest state and avoids potential issues caused by batching of state updates.
    setGa4Data(prevData => ({ ...prevData, ...newData }));
  }

  useEffect(() => {
    // console.log("ga4context::useEffect::ga4Data", ga4Data)
  }, [ga4Data])

  return (
    <Ga4Context.Provider value={ga4DataInstance}>
      {props.children}
    </Ga4Context.Provider>
  )
}
